export enum CaseMode {
    None = "None",
    AllCaps = "AllCaps",
    FirstLetterCaps = "FirstLetterCaps",
}
